import { observer } from "mobx-react";
import React from "react";
import PayloadStructureForm from "./PayloadStructureForm";
import ActionDefinitionStore from "../stores/ActionDefinitionStore";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: ActionDefinitionStore;
};

const PayloadStructureDialog: React.FC<Props> = ({ store }) => {
    return (
        <AppModal
            data-id-type="modal-window"
            data-id-name="edit-payload-structure"
            className="alpha-modal"
            title="Custom payload structure"
            open={store.editPayloadDialogVisible}
            closable={false}
            centered
            width={700}
            cancelButtonTitle="Cancel"
            onCancelClick={() => {
                store.setEditPayloadDialogVisible(false, null);
            }}
            cancelButtonProps={{
                "data-id": "button-edit-payload-structure-cancel",
            }}
            submitButtonTitle="Save"
            submitButtonProps={{
                "data-id": "button-edit-payload-structure-save",
                className: "dark",
                form: "edit-payload-structure-form",
            }}
        >
            <PayloadStructureForm store={store} />
        </AppModal>
    );
};

export default observer(PayloadStructureDialog);
